import { useEffect } from "react";
import { authcallApi, callApi } from "./API/Api";

export const Countryselect = ({ setCountry }) => {
    const userdetails = async () => {
        try {
            let postdata={}
            let res = await callApi(postdata, `api/countries`, "POST");
            if (res.success !== false) {
                setCountry(res.data?.country);
            } else {
                console.error("API error:", res.error);
            }
        } catch (err) {
            console.log(err, "error");
        }
    };

    useEffect(() => {
        userdetails();
    }, []);

}

